import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import './MainLayout.css';

/**
 * Layout principal de la aplicación
 * Incluye Header, contenido dinámico y Footer
 */
const MainLayout = () => {
    return (
        <div className="main-layout">
            <Header />
            <main className="main-layout__content">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default MainLayout;
